import { render, staticRenderFns } from "./DraggableElementsMenu.vue?vue&type=template&id=64c6f838&scoped=true&"
import script from "./DraggableElementsMenu.vue?vue&type=script&lang=js&"
export * from "./DraggableElementsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElementsMenu.vue?vue&type=style&index=0&id=64c6f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6f838",
  null
  
)

export default component.exports